export const SPACE_DEFAULT_CLASSIFICATION_OPTION_ID =
	'data-classification.space-default-classification-option';
